///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Component, ElementRef, HostListener, OnInit } from '@angular/core';
import { GtthReportsService } from '../../../../services/project/reports.service';
import { GtthHistoryService } from '../../../logical-topology/engine/history-service';
import { AbstractInteractiveWindow } from '../../abstract-interactive-window';
import { ProjectInteractiveWindowsPopupService } from '../../project-interactive-windows-popup.service';
import { GtthExportService } from '../../../../services/project/export.service';
import { PARAM_BBOX } from '../../../../shared/constants/url-params.constants';
import { ActivatedRoute } from '@angular/router';
import { GtthProjectInfoViewService } from '../../../../layouts/navbar/project-info-view.service';
import { MatDialogRef } from '@angular/material/dialog';
import { tap } from 'rxjs/operators';
import { GtthAbortOperationCommand } from '../../../logical-topology/engine/commands/design/abort-operation-command';
import { LoaderIds, PreloaderService } from '../../../../services/preloader.service';
import { finalize } from 'rxjs';

@Component({
    selector: 'winde-report-constraint-compliance',
    templateUrl: './report-constraint-compliance.component.html',
    styleUrls: ['../../project-windows.scss'],
    standalone: false
})
export class GtthReportConstraintComplianceComponent extends AbstractInteractiveWindow {
    public readonly loaderKey = LoaderIds.CONSTRAINT_COMPLIANCE_ID;
    private dataLoaded = false;
    public reportData$ = this.reportsService.generateConstraintComplianceReport().pipe(
        tap(() => (this.dataLoaded = true)),
        finalize(() => {
            this.preloaderService.hide(this.loaderKey);
            if (!this.dataLoaded) {
                this.historyService.doCommandBypassHistory(this.historyService.command(GtthAbortOperationCommand));
            }
        })
    );

    constructor(
        public readonly preloaderService: PreloaderService,
        private readonly elementRef: ElementRef,
        public dialogRef: MatDialogRef<GtthReportConstraintComplianceComponent>,
        private readonly reportsService: GtthReportsService,
        private readonly historyService: GtthHistoryService,
        private readonly exportService: GtthExportService,
        private readonly projectInfoService: GtthProjectInfoViewService
    ) {
        super(elementRef);
        this.preloaderService.show(this.loaderKey);
    }

    closeModal() {
        this.dialogRef.close('cancel');
    }

    exportToExcel() {
        this.exportService.exportConstraintComplianceReport(this.projectInfoService.activeLayer);
    }

    @HostListener('document:keydown', ['$event'])
    onKeydown(event: KeyboardEvent) {
        if (event.key === 'Escape' && !this.historyService.hasSearchMarkers()) {
            this.closeModal();
        }
    }

    designRequired(): boolean {
        return true;
    }

    isRestorable(): boolean {
        return true;
    }
}

@Component({
    selector: 'winde-report-constraint-compliance-popup',
    template: '',
    standalone: false
})
export class GtthReportConstraintCompliancePopupComponent implements OnInit {
    constructor(
        private readonly interactiveWindowsPopupService: ProjectInteractiveWindowsPopupService,
        private readonly activatedRoute: ActivatedRoute
    ) {}

    ngOnInit() {
        let bboxParams;
        if (this.activatedRoute.snapshot.queryParamMap.has(PARAM_BBOX)) {
            bboxParams = this.activatedRoute.snapshot.queryParamMap
                .get(PARAM_BBOX)
                .split(',')
                .map((value) => parseFloat(value));
        }
        const routerPath = this.activatedRoute.routeConfig.path;
        this.interactiveWindowsPopupService.openInteractiveWindow(
            GtthReportConstraintComplianceComponent,
            ProjectInteractiveWindowsPopupService.REP_CONSTRAINT_COMPLIANCE,
            routerPath,
            bboxParams
        );
    }
}
